document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.expert-quote').forEach(function (el) {
    // Skip if this quote already has its own JSON-LD directly after it
    // (sections/expert-quote.liquid renders its own schema as the next sibling).
    // The previous "any JSON-LD anywhere in the section" check was too broad —
    // it skipped article-body quotes whose containing Shopify <section> just
    // happens to also hold the article-level JSON-LD.
    var next = el.nextElementSibling;
    if (next && next.tagName === 'SCRIPT' && next.getAttribute('type') === 'application/ld+json') return;

    var blockquote = el.querySelector('blockquote');
    var cite = el.querySelector('cite');
    if (!blockquote || !cite) return;

    var quoteText = blockquote.textContent.replace(/^[„""\s]+|[„""\s]+$/g, '').trim();
    var citeText = cite.textContent.replace(/^[\s—–-]+/, '').trim();

    // Parse "Name, Berufsbezeichnung in Ort"
    var parts = citeText.split(',');
    var name = parts[0] ? parts[0].trim() : '';
    var rest = parts.slice(1).join(',').trim();
    var jobTitle = '';
    var location = '';

    if (rest) {
      var locationMatch = rest.match(/^(.+?)\s+in\s+(.+)$/);
      if (locationMatch) {
        jobTitle = locationMatch[1].trim();
        location = locationMatch[2].trim();
      } else {
        jobTitle = rest.trim();
      }
    }

    var schema = {
      '@context': 'https://schema.org',
      '@type': 'Quotation',
      'text': quoteText,
      'spokenByCharacter': {
        '@type': 'Person',
        'name': name
      }
    };

    if (jobTitle) {
      schema.spokenByCharacter.jobTitle = jobTitle;
    }

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
});
